import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "border-border flex flex-col items-center justify-center gap-2 rounded-md border p-4"
}
const _hoisted_2 = { class: "text-xs" }

import { columns } from '@/tables/columns/invoices';
    import { useI18n } from 'vue-i18n';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import { useQueryClient } from '@tanstack/vue-query';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { Company } from '@/types';
    import { CircleAlert } from 'lucide-vue-next';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerInvoicesTable',
  props: {
    company: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const queryClient = useQueryClient();

    const props = __props;

    const { hasPermission } = usePermissions();

    const { isPending, isFetching, isError, data, error, refetch, isPlaceholderData } = useQuery({
        queryKey: [QueryKey.DASHBOARD_INVOICES, props.company.id],
        queryFn: getInvoices,
        enabled: !!props.company.cvr,
        retry: false,
    });

    async function getInvoices() {
        const { data } = await axios.get(route('v2.dashboard.invoices.get'));
        return data;
    }

return (_ctx: any,_cache: any) => {
  return (!props.company.cvr)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(CircleAlert), { class: "text-muted-foreground" }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('dashboards.invoices.no_cvr')), 1)
      ]))
    : (_openBlock(), _createBlock(DataTable, {
        key: 1,
        columns: _unref(columns),
        data: _unref(data),
        loading: _unref(isPending),
        "default-sorting": [
            {
                id: 'booked_invoice_number',
                desc: true,
            },
        ],
        "enable-toolbar": false
      }, null, 8, ["columns", "data", "loading"]))
}
}

})